export const LESSON_STATUSES = 'LESSON_STATUSES';


// WEBPACK FOOTER //
// ./src/store/modules/lessonStatus/mutation-types.js